import React from "react";
import "../ProductCarousel/ProductCarousel.css";
import "../ThankYou/ThankYou.css";

export default function ThankYou() {
  return (
    <div className="thankyou-container">
      <h2 className="center">Obrigado pela sua participação.</h2>
      <h2 className="center2">
        Estamos atendendo às suas solicitações. Em breve, estaremos de volta com
        novidades!
      </h2>
    </div>
  );
}
